import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { flatMap as _flatmap} from 'lodash';
import { factory } from '@/app/shared/app-logging';
import { TemplatesPriorityService } from '@/app/services/template-priority.service';
import { CustomPriorityByEventType, EventTypeModel, TemplatePriorityModel } from '@/app/model/template.priority.model';
import { DropdownEntry } from '@/app/model/dropdown-entry';

const logger = factory.getLogger('TemplatePrioritySwitcherComponent');

const EVENT_TYPES_ORDER = ["AUDIT", "INTERNAL_TEST", "OFFICIAL", "VOLUNTARY"];

@Component({
  selector: 'app-template-priority-switcher',
  templateUrl: './priority-switcher.component.html',
  styleUrls: ['./priority-switcher.component.scss']
})
export class TemplatePrioritySwitcherComponent implements OnInit, OnChanges {

  @Input() templatePriority: TemplatePriorityModel;
  @Input() index: number;
  @Input() editEnabled: boolean;
  @Input() eventTypes: EventTypeModel[] = [];
  @Input() lengthByScreen: number;
  @Input() dropdownSelectedEntries: Array<DropdownEntry> = [];
  @Output() update: EventEmitter<TemplatePriorityModel>;

  public iconInfo: any = document.createElement(
    'dsy-icon'
  );
  public isIconVisible: boolean = false;
  public templatePriorityWithSwitcher: TemplatePriorityModel;
  public switcherComponentValueIndex: number;
  public resetSwitcher: boolean;
  public openSidebar: boolean = false;
  public eventDataSwitcher: any;
  public showMore: boolean = false;

  private switcherValuesMap = {
    HIGH: 2,
    MEDIUM: 1,
    LOW: 0
  }

  public classEventType = "visually-hidden";
  
  constructor(
    public templatePriorityService: TemplatesPriorityService
  ) {
    this.iconInfo.library = "system";
    this.iconInfo.size = "16px";
    this.update = new EventEmitter<TemplatePriorityModel>();
  }

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.templatePriority?.currentValue) {
      this.templatePriorityWithSwitcher = JSON.parse(JSON.stringify(changes.templatePriority.currentValue));
      this.switcherComponentValueIndex = this.switcherValuesMap[this.templatePriorityWithSwitcher.priority];
      this.templatePriorityWithSwitcher.switcher = [
        { title: "Low", data: { title: "LOW" } },
        { title: "Medium", data: { title: "MEDIUM" } },
        { title: "High", data: { title: "HIGH" } }
      ];
      if (
        this.templatePriorityService.getTemplatesWithByEventTypesEnabled().includes(this.templatePriorityWithSwitcher.template_name)
      ) {
        this.templatePriorityWithSwitcher.switcher.push({
          title: "By Event Type",
          data: {
            title: "By Event Type",
            openModal: () => {
              (this.resetSwitcher = true),
                this.handleEdit();
            },
          },
        });
      }
      if (this.templatePriorityWithSwitcher?.customizations && this.templatePriorityWithSwitcher?.customizations?.length > 0) {
        this.switcherComponentValueIndex = 3;
        this.templatePriority.customizations = this._sortCustomizations(this.templatePriority.customizations);
      }
    }
  }

  switcherComponent = (event?: any) => {
    this.eventDataSwitcher = { ...event };
    if (event.title === "By Event Type") {
      event.openModal();
    }
  };

  setSwitcherValue(event?: any) {
    if (this.eventDataSwitcher && this.eventDataSwitcher.title !== 'By Event Type') {
      this.update.emit({...this.templatePriority, priority: this.eventDataSwitcher.title, old_priority: this.templatePriority.priority, customizations: []});
    }
  }

  setIndexContentChosed = (index?: any) => {
    this.switcherComponentValueIndex = index;
  }

  closeSidebar(event) {
    this.openSidebar = false;
    if (event) {
      this.update.emit(this.templatePriority);
    } else {
      this.switcherComponentValueIndex = this.templatePriority.customizations?.length > 0 ? 3 : this.switcherValuesMap[this.templatePriority.priority];
    }
  }

  handleEdit() {
    this.openSidebar = true;
  }

  private _sortCustomizations = (customizations: CustomPriorityByEventType[]) => {
    return customizations.sort((a, b) => {
      const priorityA = EVENT_TYPES_ORDER.indexOf(a.event_type);
      const priorityB = EVENT_TYPES_ORDER.indexOf(b.event_type);
  
      if (priorityA === -1 && priorityB === -1) {
        // Both templates are not in the priority list, maintain original order
        return 0;
      } else if (priorityA === -1) {
        // a.template is not in the priority list, b.template is
        return 1;
      } else if (priorityB === -1) {
        // b.template is not in the priority list, a.template is
        return -1;
      } else {
        // Both templates are in the priority list, sort by their order in the priority list
        return priorityA - priorityB;
      }
    });
  };
  
}
